import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Sidebar = ({ isOpen, onClose }) => {
  const { t, isRTL } = useLanguage();

  const navItems = [
    { href: '#home', icon: 'fa-home', label: t.nav.home },
    { href: '#about', icon: 'fa-user', label: t.nav.about },
    { href: '#service', icon: 'fa-list', label: t.nav.skills },
    { href: '#portfolio', icon: 'fa-briefcase', label: t.nav.portfolio },
    { href: '#contact', icon: 'fa-comments', label: t.nav.contact },
  ];

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
    }
    if (window.innerWidth < 768) onClose();
  };

  const sidebarPosition = isRTL
    ? `fixed top-0 ${isOpen ? 'right-0' : '-right-64'} md:right-0`
    : `fixed top-0 ${isOpen ? 'left-0' : '-left-64'} md:left-0`;

  return (
    <aside className={`w-64 bg-bg-black-100 ${sidebarPosition} p-7 h-full border-${isRTL ? 'l' : 'r'} border-bg-black-50 flex flex-col z-50 transition-all duration-300`}>
      <div className="logo absolute top-12 text-3xl capitalize">
        <a href="#home" onClick={(e) => handleLinkClick(e, '#home')} className="text-text-black-900 font-semibold py-4 px-5 text-3xl tracking-widest relative logo-before logo-after">
          <span className="font-clicker text-4xl">P</span>ortfolio
        </a>
      </div>

      <div className="flex-grow flex items-center">
        <ul className="w-full p-4 flex flex-col">
          {navItems.map((item, index) => (
            <li key={index} className="mb-6">
              <a
                href={item.href}
                onClick={(e) => handleLinkClick(e, item.href)}
                className={`text-sm font-semibold block border-b border-bg-black-50 text-text-black-900 py-1 px-4 hover:text-skin-color transition-colors duration-300`}
              >
                <i className={`fa ${item.icon} ${isRTL ? 'ml-3' : 'mr-3'}`}></i>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
